import * as React from "react";
import {Button} from "../ui/button";
import {
    Command,
    CommandEmpty,
    CommandGroup,
    CommandInput,
    CommandItem,
    CommandList,
} from "../ui/command";
import {Popover, PopoverContent, PopoverTrigger} from "../ui/popover";
import {cn} from "../../lib/utils";
import {Check, ChevronsUpDown} from "lucide-react";

interface MultiSelectComboboxProps {
    types: { value: string; label: string }[];
    open: boolean;
    setOpen: React.Dispatch<React.SetStateAction<boolean>>;
    value: string[];
    onChange: (value: string[]) => void;
    width?: string;
    displayValue?: string;
}

export function MultiSelectCombobox({
                                        types,
                                        open,
                                        setOpen,
                                        value,
                                        onChange,
                                        width = "w-[532px]",
                                        displayValue

                                    }: MultiSelectComboboxProps) {
    const handleSelect = (selectedValue: string) => {

        if (value.includes(selectedValue)) {
            onChange(value.filter((val) => val !== selectedValue));
        } else {
            onChange([...value, selectedValue]);
        }

    };

    const clearSelection = () => {
        onChange([]);
    };

    return (
        <Popover open={open} onOpenChange={setOpen}>
            <PopoverTrigger asChild>
                <Button
                    variant="outline"
                    role="combobox"
                    aria-expanded={open}
                    className="w-full justify-between"
                >
                    {displayValue
                        ? displayValue
                        : value.length > 0
                            ? value
                                .map((val) => types.find((type) => type.value === val)?.label)
                                .join(", ")
                            : "Select ..."}
                    <ChevronsUpDown className="ml-2 h-4 w-4 shrink-0 opacity-50"/>
                </Button>
            </PopoverTrigger>
            <PopoverContent className={`${width} p-0`}>
                <Command>
                    <CommandInput placeholder="Search ..."/>
                    {/*// todo - need a 'clear selection'*/}
                    <CommandList>
                        <CommandEmpty>No types found.</CommandEmpty>
                        <CommandGroup>
                            {types.map((type) => (
                                <CommandItem
                                    key={`${type.value}-${type.label}`}
                                    value={type.value}
                                    onSelect={() => {
                                        handleSelect(type.value);
                                        setOpen(false);
                                    }}
                                >
                                    <Check
                                        className={cn(
                                            "mr-2 h-4 w-4",
                                            value.includes(type.value)
                                                ? "opacity-100"
                                                : "opacity-0"
                                        )}
                                    />
                                    {type.label}
                                </CommandItem>
                            ))}
                            <CommandItem className="h-10">
                                <Button onClick={() => {
                                    clearSelection()
                                    setOpen(false)
                                }} className="m-2" variant="ghost">
                                    Clear Selection
                                </Button>
                            </CommandItem>
                        </CommandGroup>
                    </CommandList>
                </Command>
            </PopoverContent>
        </Popover>
    );
}
